import type { SelectedOperation } from '~/server/logic/prisma/operation-select';
import type { SelectedStep } from '~/server/logic/prisma/step-select';
import { opModelToSelectedOp } from '~/server/logic/steps/operation/op-model-to-seleceted-op-converter';
import type { RouterInputs } from '~/trpc-extra/api';

export function spliceInSteps(steps: SelectedStep[], newOperation: SelectedOperation) {
  if (newOperation.testStep === null) {
    throw new Error('Need step data to update');
  }
  const stepToUpdate = steps.find((step) => step.id === newOperation.testStep?.id);
  if (!stepToUpdate) {
    throw new Error('Step not found');
  }

  const updatedOperations = stepToUpdate.operations.map((operation) =>
    operation.order >= newOperation.order ? { ...operation, order: operation.order + 1 } : operation,
  );
  // Find the correct index to insert the new operation
  const insertIndex = updatedOperations.findIndex((operation) => operation.order > newOperation.order);

  // Insert the new operation at the correct index
  updatedOperations.splice(insertIndex === -1 ? updatedOperations.length : insertIndex, 0, newOperation);

  return steps.map((step) => (step.id === stepToUpdate.id ? { ...stepToUpdate, operations: updatedOperations } : step));
}

export function getDummyOperation({
  operation: newOperation,
}: RouterInputs['operation']['upsertOperation']): SelectedOperation {
  const now = new Date();
  return {
    ...opModelToSelectedOp(newOperation),
    id: newOperation.operationId ?? `op_${now.getTime()}`,
  };
}
